import * as echarts from 'echarts'
import request from '@/config/request.js'
import moment from 'moment'
const ApiRenewal = request.Renewal
import common from '@/components/common/'
import moethods from '@/util/tools/common_methods.js'
import { formatDate } from '@/util/tools/date.js'
import { Message } from 'element-ui'

import sseMixin from '../../../../mixins/sseMixin'
import { streamPost, streamGet } from '../../../../config/ajaxRequest.js';


const ApiUser = request.UserLogin



export default {
    components: {
      ...common,
    },
     mixins: [sseMixin],
  data() {
    return {
       loading: false,
      streamContent: '',
      reasoningStream: '',
      showReasoning: false,
      thinkingDone: false,
      cancelStream: null, // 保存取消函数
   

      schoolZones: [],
      zoneId: '',
      zoneName: '',
      kpiList: [],

      semesterRevenue: {},
      semesterProfit: {},
      costCategoryComposition: {},
      coreCostComposition: {},
      refundReasonComposition: {},
      yearRevenueTrend: {},
      yearCost: {},
      serviceCategoryComposition: {},
      refundClassComposition: {},
      gradeRevenue: {},

      moethods: moethods,
 
      // classAttendYearRange: [
      //   moment().format('YYYY'),
      //   moment().add(1, 'year').format('YYYY')
      // ],
      classAttendYearRange: '',
      periodOptions:[
        {
          value: 'year',
          label: '全年'
        },
        {
          value: 'autumn',
          label: '秋季'
        },
        {
          value: 'winter',
          label: '寒假'
        },
        {
          value: 'spring',
          label: '春季'
        },
        {
          value: 'summer',
          label: '暑假'
        }
      ],
      period: 'year',

      gradePeriod: 'year',
      gradePeriodRevenue: {},

      yearRangeAcademic: [
        moment().format('YYYY'),
        moment().add(1, 'year').format('YYYY')
      ],
      yearRangeCost: [
        moment().format('YYYY'),
        moment().add(1, 'year').format('YYYY')
      ],
      kpiList1: [],

      compositionPeriod: 'year',
      coreCostPeriod: 'year',

      refundReasonPeriod: 'year',

      yearRangeProfit: [
        moment().format('YYYY'),
        moment().add(1, 'year').format('YYYY')
      ],
     
      aiText: '',
      chartInstances: {
        echartData1: null,
        echartData2: null,
        echartData3: null,
        echartData4: null,
        echartData5: null,
        echartData6: null,
        echartData7: null,
        echartData8: null
      },
      echartData1: {},
        echartData2: {},
      echartData3: {},
      echartData4: {},
      echartData5: {},
        echartData6: {},
        echartData7: {},
      echartData8: {},
      classAttendMonth: '',
      timeTable: [],
      revenueCost: '',
      revenueCostOptions: [
        {
          value: 'revenue',
          label: '收入分析'
        },
        {
          value: 'cost',
          label: '成本分析'
        }
      ],
    }
  },
  computed: {
    kpiColStyle() {
      const w = (100 / 6).toFixed(6) + '%'
      return { flex: '0 0 ' + w, maxWidth: w, display: 'block'}
    },
    kpiTwoColStyle() {
      const w = (100 / 6 * 2).toFixed(6) + '%'
      return { flex: '0 0 ' + w, maxWidth: w }
    },
    kpiFourColStyle() {
      const w = (100 / 6 * 4).toFixed(6) + '%'
      return { flex: '0 0 ' + w, maxWidth: w }
    },
    kpiSixColStyle() {
      const w = (100 / 6 * 6).toFixed(6) + '%'
      return { flex: '0 0 ' + w, maxWidth: w }
    }
    ,
    // yearRangeOutput() {
    //   const v = Array.isArray(this.classAttendYearRange)
    //     ? this.classAttendYearRange
    //     : []
    //   const s = String(v[0] || '').trim()
    //   const e = String(v[1] || '').trim()
    //   if (!s || !e) return ''
    //   return s + '-' + e + '年'
    // },
    yearRangeAcademicOutput() {
      const v = Array.isArray(this.yearRangeAcademic)
        ? this.yearRangeAcademic
        : []
      const s = String(v[0] || '').trim()
      const e = String(v[1] || '').trim()
      if (!s || !e) return ''
      return s + '-' + e + '年'
    },
    yearRangeCostOutput() {
      const v = Array.isArray(this.yearRangeCost)
        ? this.yearRangeCost
        : []
      const s = String(v[0] || '').trim()
      const e = String(v[1] || '').trim()
      if (!s || !e) return ''
      return s + '-' + e + '年'
    },
    yearRangeProfitOutput() {
      const v = Array.isArray(this.yearRangeProfit)
        ? this.yearRangeProfit
        : []
      const s = String(v[0] || '').trim()
      const e = String(v[1] || '').trim()
      if (!s || !e) return ''
      return s + '-' + e + '年'
    },
  },
 async mounted () {
    this.zoneId = (this.$store && this.$store.state &&
    this.$store.state.login) ? this.$store.state.login.zoneId : ''

    let str = (this.$store && this.$store.state &&
    this.$store.state.login) ? this.$store.state.login.userInfo : ''
    this.zoneName = JSON.parse(str).zoneName || ''

    await this.initListZoneSemester()


    this.initZones()

    this.initEchart()
    this.initData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    Object.keys(this.chartInstances).forEach(k => {
      if (this.chartInstances[k]) this.chartInstances[k].dispose()
    })
  },
  methods: {
    initListZoneSemester () {
      return new Promise((resolve) => {
        this.timeTable = []
        ApiUser.listZoneSemester.call(this, {}, (res) => {
          const items = Array.isArray(res) ? res : []
          let def = null
          for (let i = 0; i < items.length; i++) {
            const item = items[i] || {}
            const data = {
              id: item.id,
              yearValue: item.year,
              isDefault: !!item.isDefault
            }
            this.timeTable.push(data)
            if (item.isDefault && !def) def = item
          }
          if (def && def.year) {
            this.classAttendYearRange = def.year
          } else if (items.length > 0 && items[0] && items[0].year) {
            this.classAttendYearRange = items[0].year
          }
          resolve()
        })
      })
    },

    goBack() { this.$router && this.$router.go(-1) },
    initData () {
       this.initOverview()
       this.initYearCost()

       window.addEventListener('resize', this.onResize)
    },
    onChangeYearRangeAcademic () {
      this.initOverview()
      this.initYearRevenueTrend()
      this.initYearCost()
      this.initYearProfit()

      this.initServiceCategoryComposition()
      this.initGradePeriodRevenue()
      this.initCostCategoryComposition()
      this.initCoreCostComposition()
      this.initRefundData()
    },

    initEchart () {
      
      this.initServiceCategoryComposition()
      this.initGradePeriodRevenue()
      this.initYearRevenueTrend()
      this.initCostCategoryComposition()
      this.initCoreCostComposition()

      this.initRefundData()

      this.initYearProfit()
      
    },
    initRefundData () {
      this.initRefundReasonComposition()
      this.initRefundClassComposition()
    },
    
    onAIstartDiagnosis () {
      if (typeof this.cancelStream === 'function') this.cancelStream()
      this.streamContent = ''
      let str = {
        semesterRevenue: this.semesterRevenue,
        semesterProfit: this.semesterProfit,
        costCategoryComposition: this.costCategoryComposition,
        coreCostComposition: this.coreCostComposition,
        refundReasonComposition: this.refundReasonComposition,
        yearRevenueTrend: this.yearRevenueTrend,
        yearCost: this.yearCost,
        serviceCategoryComposition: this.serviceCategoryComposition,
        gradeRevenue: this.gradeRevenue,
        refundClassComposition: this.refundClassComposition,
        zoneId: this.zoneId,
      }
      // console.log(str, '=======')

      function toBase64Url(text){
        const b64=btoa(unescape(encodeURIComponent(text)));
        return b64.replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
      }
        const json =JSON.stringify(str);
        const b64url=toBase64Url(json);
        // console.log(b64url, 'b64url=======')

       const params =new URLSearchParams({
         templateCategory:'FINANCIAL_DIAGNOSIS',
         metricsB64:b64url
       });

      console.log(params.toString(), 'params=======')

      this.loading = true
       this.streamContent = ''
       this.reasoningStream = ''
      this.cancelStream = streamGet(
      'https://angelbell.anqinyun.com/app/rest/school/auth/dashboard/aiOperationDiagnosis',
      params,
      (data) => {
        const full = data && data.full
        const delta = typeof data === 'string'
          ? data
          : ((data && data.content) || (data && data.message && data.message.content) || '')
        const rc = data && data.reasoning_content

        const hasMain = (typeof delta === 'string' && delta) || (data && data.done && typeof full === 'string')
        if (hasMain) {
          if (typeof delta === 'string' && delta) {
            this.streamContent += delta
          }
          if (data && data.done && typeof full === 'string') {
            this.streamContent = full
          }
          // this.thinkingDone = true
          // this.showReasoning = false
        } else if (typeof rc === 'string' && rc) {
          this.reasoningStream += rc
          // if (!this.thinkingDone) this.showReasoning = true
        }
      },
      (err) => { // 错误回调
        console.error('流式请求错误：', err);
      },
      () => { // 流结束回调
        this.loading = false
        console.log('流式请求完成2');
      }
    );

    },


    selectCommand (zoneId) {
      this.zoneId = zoneId
      this.zoneName = this.schoolZones.find(z => z.zoneId === zoneId).zoneName || ''
      this.initData()
      this.initEchart()
    },
    initZones () {
      var zoneTeacher = (this.$store && this.$store.state &&
        this.$store.state.login) ? this.$store.state.login.zoneTeacher : null
      var accountId = ''
      try {
        var obj = (typeof zoneTeacher === 'string') ? JSON.parse(zoneTeacher) : zoneTeacher
        accountId = (obj && obj.teacher && obj.teacher.accountId)
          ? obj.teacher.accountId : ''
      } catch (e) {
        accountId = ''
      }
      if (!accountId) {
        this.schoolZones = []
        return
      }
      ApiRenewal.getZones.call(this, { accountId: accountId }, (data) => {
        this.schoolZones = data
      })
    },
    initOverview () {
      ApiRenewal.getSemesterRevenue.call(this, {zoneId: this.zoneId, academicYear: this.classAttendYearRange},(data) => {
        this.semesterRevenue = data || {}

        const labelMap = {
          autumnRevenue: '秋季营收(元)/客单价(元/月)',
          winterRevenue: '寒假营收(元)/客单价(元/月)',
          springRevenue: '春季营收(元)/客单价(元/月)',
          summerRevenue: '暑假营收(元)/客单价(元/月)',
          totalRevenue: '营收合计(元)',
          averagePrice: '校区客单价(元)'
        }
        const rateKeys = []
        const keys = [
          'autumnRevenue',
          'winterRevenue',
          'springRevenue',
          'summerRevenue',
          'totalRevenue',
          'averagePrice'
        ]
        const fmt = (k, v) => {
          if (rateKeys.includes(k)) {
            const n = Number(v || 0)
            return (Number.isFinite(n) ? n.toFixed(2) : '0') + '%'
          }
          let price = ''
          console.log(k, data, v, '========')
          if (k === 'autumnRevenue' || k === 'winterRevenue' || k === 'springRevenue' || k === 'summerRevenue') {
            if (k === 'autumnRevenue') {
              price = data['autumnAveragePrice']
            } 
            if (k === 'winterRevenue') {
              price = data['winterAveragePrice']
            }
            if (k === 'springRevenue') {
              price = data['springAveragePrice']
            }
            if (k === 'summerRevenue') {
              price = data['summerAveragePrice']
            }
          }
          return String(v == null ? 0 : v)  + (price ? ' / ' + price : '')
        }
        const list = keys.map(k => ({
          key: k,
          label: labelMap[k],
          value: fmt(k, data && data[k])
        }))
        this.kpiList = list
      })
    },
    initServiceCategoryComposition () {
      let param = {
        "zoneId": this.zoneId,
        "period": this.period,
        "academicYear": this.classAttendYearRange
       }
      ApiRenewal.getServiceCategoryComposition.call(this, param,(res) => {
        this.serviceCategoryComposition = res || {}
        const items = res || []

         const el = this.$refs.echartData1
          if (!el) return
          const chart1 = echarts.init(el)
          this.chartInstances.echartData1 = chart1

      const data = items.map(item => ({ name: item.serviceCategory ? item.serviceCategory : '-', value: item.amount || 0 }))
      const legendData = items.map(item => item.serviceCategory ? item.serviceCategory : '-')

          chart1.setOption({
        tooltip : {
            trigger: 'item',
            formatter: "{b} <br/> {c} ({d}%)"
        },
        legend: {
            x : 'center',
            y : 'bottom',
            data:legendData, textStyle: { color: '#8aa4c9' }
        },
        calculable : true,
        series : [
            {
               type: 'pie',
            radius: ['20%','50%'],
             label: { formatter: '{b}: {c} ({d}%)', color: '#cfe3ff' },
            roseType : 'radius',
            selectedMode: 'single',
            max: 40,            // for funnel
            data:data,
           }
         ]
        })
          })
    },
    initGradePeriodRevenue () {
      let param = {
        "zoneId": this.zoneId,
        "period": this.gradePeriod,
        "academicYear": this.classAttendYearRange
       }
      ApiRenewal.getGradePeriodRevenue.call(this, param,(res) => {
        this.gradeRevenue = res || {}
        const items = res || []

        const el2 = this.$refs.echartData2
        if (!el2) return
        const chart2 = echarts.init(el2)
        this.chartInstances.echartData2 = chart2  
        const label = items.map(i => (i && i.label != null) ? (i.label) : '-')
      const values = items.map(i => (i && i.value != null) ? Number(i.value) : 0)

        chart2.setOption({
            grid: { left: 60, right: 20, top: 70, bottom: 20 },
            tooltip: {
                trigger: 'axis',
                formatter: (params) => {
                  const date = params[0].name
                  const value = params[0].value
                  return `${date}<br>营收: ${value}`
                },
              },
            
            calculable : true,
            xAxis: {
              type: 'category',
              data: label,
              axisLabel: { color: '#8aa4c9' },
              axisLine: { lineStyle: { color: '#274063' } },
              axisTick: { lineStyle: { color: '#274063' } }
            },
            yAxis: {
              type: 'value',
              // name: '月度浏览趋势',
              nameTextStyle: { color: '#8aa4c9' },
              axisLabel: { color: '#8aa4c9' },
              axisLine: { lineStyle: { color: '#274063' } },
              axisTick: { lineStyle: { color: '#274063' } },
              splitLine: { lineStyle: { color: '#1c2f4a' } }
            },
            series: [
              { type: 'bar', data: values, barWidth: 20, itemStyle: { color: '#4f8ef7' } }
            ]
        })
      })
    },
    initYearRevenueTrend () {
      let param = {
        "zoneId": this.zoneId,
        "academicYear": this.classAttendYearRange//this.yearRangeAcademicOutput
       }
      ApiRenewal.getYearRevenueTrend.call(this, param,(res) => {
        this.yearRevenueTrend = res || {}
        const current = (res && res.current) || {}
        const previous = (res && res.previous) || {}
        const labelMap = {
          autumnRevenue: '秋季营收',
          winterRevenue: '寒假营收',
          springRevenue: '春季营收',
          summerRevenue: '暑假营收',
          // totalRevenue: '营收合计',
          // averagePrice: '校区客单价',
          // orderCount: '订单数'
        }
        const keys = [
          'autumnRevenue',
          'winterRevenue',
          'springRevenue',
          'summerRevenue',
          // 'totalRevenue',
          // 'averagePrice',
          // 'orderCount'
        ]
        const labels = keys.map(k => labelMap[k])
        const curr = keys.map(k => {
          const v = current[k]
          const n = Number(v)
          return Number.isFinite(n) ? n : 0
        })
        const prev = keys.map(k => {
          const v = previous[k]
          const n = Number(v)
          return Number.isFinite(n) ? n : 0
        })
         const el3 = this.$refs.echartData3
        if (!el3) return
        const chart3 = echarts.init(el3)
        this.chartInstances.echartData3 = chart3    
        chart3.setOption({

          grid: { left: 55, right: 20, top: 70, bottom: 20 },
          tooltip : {
              trigger: 'axis'
          },
          legend: {
              data:['本学年','上学年'], textStyle: { color: '#8aa4c9' }
          },
          
          calculable : true,
          xAxis : [
              {
                  type : 'category',
                  // boundaryGap : false,
                  data : labels,
                  axisLabel: { color: '#8aa4c9' },
            axisLine: { lineStyle: { color: '#274063' } },
            axisTick: { lineStyle: { color: '#274063' } }
              }
          ],
          yAxis : [
              {
                  type : 'value',
                  nameTextStyle: { color: '#8aa4c9' },
            axisLabel: { color: '#8aa4c9' },
            axisLine: { lineStyle: { color: '#274063' } },
            axisTick: { lineStyle: { color: '#274063' } },
            splitLine: { lineStyle: { color: '#1c2f4a' } }
              }
          ],
          series : [
              {
                  name:'本学年',
                  type:'bar',
                  // smooth:true,
                  itemStyle: {normal: {areaStyle: {type: 'default'}}},
                  data: curr
              },
              {
                  name:'上学年',
                  type:'bar',
                  smooth:true,
                  itemStyle: {normal: {areaStyle: {type: 'default'}}},
                  data: prev
              }
          ]
      })
      })
    },
    initYearCost () {
      let param = {
        "zoneId": this.zoneId,
        "academicYear": this.classAttendYearRange//this.yearRangeCostOutput
       }
      ApiRenewal.getYearCost.call(this, param,(data) => {
        console.log(data, '11111')
        this.yearCost = data || {}
        const labelMap = {
          autumnCost: '秋季成本',
          winterCost: '寒假成本',
          springCost: '春季成本',
          summerCost: '暑假成本',
          totalCost: '成本合计'
        }
        const keys = [
          'autumnCost',
          'winterCost',
          'springCost',
          'summerCost',
          'totalCost'
        ]
        const fmt = (k, v) => {
          return String(v == null ? 0 : v)
        }
        const list = keys.map(k => ({
          key: k,
          label: labelMap[k],
          value: fmt(k, data && data[k])
        }))
        console.log(list, '==========')
        this.kpiList1 = list
        
      })
    },
    initCostCategoryComposition () {
      let param = {
        "zoneId": this.zoneId,
        "period": this.compositionPeriod,
        "academicYear": this.classAttendYearRange
       }
      ApiRenewal.getCostCategoryComposition.call(this, param,(res) => {
        this.costCategoryComposition = res || {}
        const items = res || []

        const el4 = this.$refs.echartData4
        if (!el4) return
        const chart4 = echarts.init(el4)
        this.chartInstances.echartData4 = chart4  
        const label = items.map(i => (i && i.label != null) ? (i.label) : '-')
      const values = items.map(i => (i && i.value != null) ? Number(i.value) : 0)

        chart4.setOption({
          grid: { left: 60, right: 20, top: 70, bottom: 20 },
          tooltip: {
              trigger: 'axis',
              formatter: (params) => {
                const date = params[0].name
                const value = params[0].value
                return `${date}<br>成本: ${value}`
              },
            },
          
          calculable : true,
          xAxis: {
            type: 'category',
            data: label,
            axisLabel: { color: '#8aa4c9' },
            axisLine: { lineStyle: { color: '#274063' } },
            axisTick: { lineStyle: { color: '#274063' } }
          },
          yAxis: {
            type: 'value',
            // name: '月度浏览趋势',
            nameTextStyle: { color: '#8aa4c9' },
            axisLabel: { color: '#8aa4c9' },
            axisLine: { lineStyle: { color: '#274063' } },
            axisTick: { lineStyle: { color: '#274063' } },
            splitLine: { lineStyle: { color: '#1c2f4a' } }
          },
          series: [
            { type: 'bar', data: values, barWidth: 20, itemStyle: { color: '#4f8ef7' } }
          ]
      })
      })
    },
    initCoreCostComposition () {
      let param = {
        "zoneId": this.zoneId,
        "period": this.coreCostPeriod,
        "academicYear": this.classAttendYearRange
       }
      ApiRenewal.getCoreCostComposition.call(this, param,(res) => {
        this.coreCostComposition = res || {}
        const items = res || []

        const el5 = this.$refs.echartData5
        if (!el5) return
        const chart5 = echarts.init(el5)
        this.chartInstances.echartData5 = chart5  
        const data = items.map(item => ({ name: item.category, value: item.amount || 0 }))
      const legendData = items.map(item => item.category)
      console.log('legendData', legendData, data, '======') 
        chart5.setOption({
       tooltip : {
            trigger: 'item',
            formatter: "{b} <br/> {c} ({d}%)"
        },
        legend: {
            x : 'center',
            y : 'bottom',
            data:legendData, textStyle: { color: '#8aa4c9' }
        },
        series : [
            {
              type: 'pie',
            selectedMode: 'single',
            label: { formatter: '{b}: {c} ({d}%)', color: '#cfe3ff' },
              radius: '50%',
              data:data
           }
         ]
        })
      })
    },
    initRefundReasonComposition () {
      let param = {
        "zoneId": this.zoneId,
        "period": this.refundReasonPeriod,
        "academicYear": this.classAttendYearRange
       }
      ApiRenewal.getRefundReasonComposition.call(this, param,(res) => {
        this.refundReasonComposition = res || {}
        const items = res || []

        const el6 = this.$refs.echartData6
        if (!el6) return
        const chart6 = echarts.init(el6)
        this.chartInstances.echartData6 = chart6  
        const label = items.map(i => (i && i.label != null) ? (i.label) : '-')
      const values = items.map(i => (i && i.value != null) ? Number(i.value) : 0)

        chart6.setOption({
          grid: { left: 90, right: 50, top: 30, bottom: 30 },
          tooltip: {
              trigger: 'axis',
              formatter: (params) => {
                const date = params[0].name
                const value = params[0].value
                return `${date}<br>人数: ${value}`
              },
            },
          title : {
            text: '退费原因分析',
            x:'left',
            textStyle: { color: '#cfe3ff' ,fontSize: 12 },
            subtext: '退费(人/次)',
            subtextStyle: { color: '#d1e2faff' ,fontSize: 10 },
          },
          xAxis: {
            type: 'value',
            axisLabel: { color: '#8aa4c9' },
            axisLine: { lineStyle: { color: '#274063' } },
            splitLine: { lineStyle: { color: '#1c2f4a' } } },
          yAxis: {
            type: 'category',
            data: label,
            axisLabel: { color: '#8aa4c9' },
            axisLine: { lineStyle: { color: '#8aa4c9' } } },
          series: [
            { type: 'bar', data: values, barWidth: 18, itemStyle: { color: '#4f8ef7' }, label: { show: true, position: 'right', color: '#cfe3ff' } }
          ]
        })
      })
    },
    initRefundClassComposition () {
      let param = {
        "zoneId": this.zoneId,
        "period": this.refundReasonPeriod,
        "academicYear": this.classAttendYearRange
       }
      ApiRenewal.getRefundClassComposition.call(this, param,(res) => {
        this.refundClassComposition = res || {}
        const items = res || []

        const el7 = this.$refs.echartData7
        if (!el7) return
        const chart7 = echarts.init(el7)
        this.chartInstances.echartData7 = chart7  
        const label = items.map(i => (i && i.label != null) ? (i.label) : '-')
      const values = items.map(i => (i && i.value != null) ? Number(i.value) : 0)

        chart7.setOption({
          grid: { left: 60, right: 20, top: 70, bottom: 20 },
          tooltip: {
              trigger: 'axis',
              formatter: (params) => {
                const date = params[0].name
                const value = params[0].value
                return `${date}<br>人数: ${value}`
              },
            },
           title : {
            text: '班级退费分析',
            x:'left',
            textStyle: { color: '#cfe3ff' ,fontSize: 12 },
            subtext: '退费(人/次)',
            subtextStyle: { color: '#d1e2faff' ,fontSize: 10 },
          },
          calculable : true,
          xAxis: {
            type: 'category',
            data: label,
            axisLabel: { color: '#8aa4c9' },
            axisLine: { lineStyle: { color: '#274063' } },
            axisTick: { lineStyle: { color: '#274063' } }
          },
          yAxis: {
            type: 'value',
            nameTextStyle: { color: '#8aa4c9' },
            axisLabel: { color: '#8aa4c9' },
            axisLine: { lineStyle: { color: '#274063' } },
            axisTick: { lineStyle: { color: '#274063' } },
            splitLine: { lineStyle: { color: '#1c2f4a' } }
          },
          series: [
            { type: 'bar', data: values, barWidth: 20, itemStyle: { color: '#4f8ef7' } }
          ]
      })
      })
    },
    initYearProfit () {
      let param = {
        "zoneId": this.zoneId,
        "academicYear": this.classAttendYearRange,//this.yearRangeProfitOutput,
        
       }
      ApiRenewal.getYearProfit.call(this, param,(res) => {
       this.semesterProfit = res || {}
        const labelMap = {
          autumnProfit: '秋季',
          winterProfit: '寒假',
          springProfit: '春季',
          summerProfit: '暑假',
        }
        // const labelMapRate = {
        //   autumnProfitRate: '秋季',
        //   winterProfitRate: '寒假',
        //   springProfitRate: '春季',
        //   summerProfitRate: '暑假', 
        // }
        const keys = [
          'autumnProfit', 
          'winterProfit', 
          'springProfit', 
          'summerProfit',
        ]
        const keysRate = [
          'autumnProfitRate', 
          'winterProfitRate', 
          'springProfitRate', 
          'summerProfitRate'
        ]
        const labels = keys.map(k => labelMap[k])
        // const labelsRate = keysRate.map(k => labelMapRate[k])

        const curr = keys.map(k => {
          const v = res[k]
          const n = Number(v)
          return Number.isFinite(n) ? n : 0
        })
        const prev = keysRate.map(k => {
          const v = res[k]
          const n = Number(v)
          return Number.isFinite(n) ? n : 0
        })
         const el8 = this.$refs.echartData8
        if (!el8) return
        const chart8 = echarts.init(el8)
        this.chartInstances.echartData8 = chart8    
        chart8.setOption({

          grid: { left: 50, right: 50, top: 70, bottom: 20 },
          tooltip : {
              trigger: 'axis'
          },
          legend: {
              data:['净利润（元)','净利润率（%)'], textStyle: { color: '#8aa4c9' }
          },
          
          calculable : true,
          xAxis : [
              {
                 type : 'category',
                  boundaryGap : false,
                  data : labels,
                  // axisLabel: { color: '#8aa4c9' },
                  // axisLine: { lineStyle: { color: '#274063' } },
                  // axisTick: { lineStyle: { color: '#274063' } },
                  splitLine:{show: false}
              },
            //   {
            //       type : 'category',
            //       boundaryGap : false,
            //       data : labelsRate,
            //       axisLabel: { color: '#8aa4c9' },
            // axisLine: { lineStyle: { color: '#274063' } },
            // axisTick: { lineStyle: { color: '#274063' } }
            //   }
          ],
          yAxis : [
              {
                name : '净利润（元)',
                  type : 'value',
                  nameTextStyle: { color: '#8aa4c9' },
                  axisLabel: { color: '#8aa4c9' },
                  axisLine: { lineStyle: { color: '#274063' } },
                  axisTick: { lineStyle: { color: '#274063' } },
                  splitLine: { lineStyle: { color: '#1c2f4a' }, show: false }
              },
              {
                  name : '净利润率（%)',
                  type : 'value',
                  splitLine: { lineStyle: { color: '#1c2f4a' }, show: false }
              }
          ],
          series : [
              {
                  name:'净利润（元)',
                  type:'line',
                  smooth:true,
                  // itemStyle: {normal: {areaStyle: {type: 'default'}}},
                  data: curr
              },
              {
                  name:'净利润率（%)',
                  type:'line',
                  yAxisIndex:1,
                  smooth:true,
                  // itemStyle: {normal: {areaStyle: {type: 'default'}}},
                  data: prev
              }
          ]
      })
      })
    },




    



    
    onResize() {
      Object.values(this.chartInstances).forEach(i => {
        if (i) i.resize()
      })
    },

    
    

    initCampusInfo () {
      let param = {
        "zoneId": this.zoneId
       }
      ApiRenewal.getCampusInfo.call(this, param,(res) => {
        this.campusInfo = res?.data || {}
      })
    },
    initTrainingAnnual () {
      let param = {
        "zoneId": this.zoneId,
        "year": this.trainingYear ? moment(this.trainingYear).format('YYYY') : moment().format('YYYY'),
        
       }
      ApiRenewal.getTrainingAnnual.call(this, param,(res) => {
        this.trainingAnnual = res?.data?.list || []
        this.trainingSummary = res?.data?.summary || {}
      })
    },
    fmtDate(d) {
      return formatDate(d)
    }
  }
}
